<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Nombre</label>
          <input type="text" class="form-control form-control-sm" readonly="readonly" v-model="formGeocerca.nombre" />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Tipo Geocerca</label>
          <select class="form-control form-control-sm" v-model="formGeocerca.tipo_geocerca">
            <option value="">Seleccione...</option>
            <option v-for="tipo_geocerca in listasForms.tipos_geocerca" :key="tipo_geocerca.numeracion" :value="tipo_geocerca.numeracion">
              {{ tipo_geocerca.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Estado</label>
          <select class="form-control form-control-sm" v-model="formGeocerca.estado">
            <option value="">Seleccione...</option>
            <option v-for="estado in estadosLista" :key="estado.numeracion" :value="estado.numeracion">
              {{ estado.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary float-right mt-4" @click="saveGeocerca()">
          <i class="fas fa-save"></i>
        </button>
      </div>
    </div>
    <div class="row" v-if="formGeocerca != null">
      <div class="col-md-12">
        <TepSitioMapPoli v-if="formGeocerca.tipo_geocerca == 1" ref="TepSitioMapPoli" :entity="entityData" />
        <TepSitioMapCir v-if="formGeocerca.tipo_geocerca == 2" ref="TepSitioMapCir" :entity="entityData" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TepSitioMapPoli from "./TepSitioMapPoli.vue";
import TepSitioMapCir from "./TepSitioMapCir.vue";

export default {
  name: "TepSitioGeocerca",
  props: {
    entity: {
      type: Object,
      default: null,
    },
    estados: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TepSitioMapPoli,
    TepSitioMapCir,
  },
  data() {
    return {
      formGeocerca: {
        tipo_geocerca: null,
        nombre: null,
        estado: null,
      },
      listasForms: {
        tipos_geocerca: [],
      },
    };
  },
  computed: {
    entityData() {
      if (this.entity) return this.entity;
      if (this.$parent && this.$parent.gestion) return this.$parent.gestion;
      return {};
    },
    estadosLista() {
      if (Array.isArray(this.estados) && this.estados.length > 0) return this.estados;
      if (this.$parent && this.$parent.listasForms && this.$parent.listasForms.estados) return this.$parent.listasForms.estados;
      return [];
    },
  },
  watch: {
    entityData: {
      handler() {
        this.getIndex();
      },
      deep: true,
    },
  },
  methods: {
    setLoading(value) {
      this.$emit("loading", value);
      if (this.$parent && typeof this.$parent.cargando !== "undefined") {
        this.$parent.cargando = value;
      }
    },
    getIndex() {
      if (!this.entityData || !this.entityData.id) return;
      if (this.entityData.geocerca != null) {
        this.formGeocerca.geocerca_id = this.entityData.geocerca.id;
        this.formGeocerca.tipo_geocerca = this.entityData.geocerca.tipo_geocerca;
        this.formGeocerca.estado = this.entityData.geocerca.estado;
      } else {
        this.formGeocerca.geocerca_id = null;
        this.formGeocerca.tipo_geocerca = null;
        this.formGeocerca.estado = 1;
      }
      this.formGeocerca.nombre = "GEOCERCA SITIO " + this.entityData.nombre;
      if (!this.formGeocerca.estado) this.formGeocerca.estado = 1;
    },
    getTiposGeocerca() {
      axios.get("/api/lista/29").then((response) => {
        this.listasForms.tipos_geocerca = response.data;
      });
    },
    saveGeocerca() {
      if (!this.entityData || !this.entityData.id) return;
      this.setLoading(true);
      this.formGeocerca.sitio_id = this.entityData.id;

      if (this.formGeocerca.tipo_geocerca == 1 && this.$refs.TepSitioMapPoli) {
        this.formGeocerca.longitud = this.$refs.TepSitioMapPoli.paths[0][0].lng;
        this.formGeocerca.latitud = this.$refs.TepSitioMapPoli.paths[0][0].lat;
        this.formGeocerca.paths = this.$refs.TepSitioMapPoli.paths[0];
      } else if (this.formGeocerca.tipo_geocerca == 2 && this.$refs.TepSitioMapCir) {
        this.formGeocerca.longitud = this.$refs.TepSitioMapCir.reportedCenter.lng;
        this.formGeocerca.latitud = this.$refs.TepSitioMapCir.reportedCenter.lat;
        this.formGeocerca.radio = this.$refs.TepSitioMapCir.radius;
      } else {
        this.setLoading(false);
        return;
      }

      axios({
        method: "PUT",
        url: "/api/tep/sitios/saveGeocerca",
        data: this.formGeocerca,
      })
        .then((response) => {
          this.setLoading(false);
          this.formGeocerca.geocerca_id = response.data.id;
          this.$swal({
            icon: "success",
            title: "Geocerca guardada exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.setLoading(false);
          this.$swal({
            icon: "error",
            title: "Ocurrio un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
  mounted() {
    this.getTiposGeocerca();
    this.getIndex();
  },
};
</script>
